import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IJobBase, JobWorkingForm } from '@/types'
import { getFormattedAmount } from '@/utils'
import { ContentOverviewItem } from '@/componentsV2/atoms/ContentOverviewItem'
import { Badge } from '@/componentsV2/atoms/Badge'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobContentOverview: FC<Props> = ({ job }) => {
  const { t } = useTranslation(['jobs-[job_slug]', 'jobs'])
  return (
    <div className={styles.container}>
      <ContentOverviewItem label={t('募集形態')} text={t(`jobs:${job?.typeOfPosition}`)} />
      {job?.primaryJobCategory && (
        <div className={styles.content}>
          <div className={styles.label}>{t('職種')}</div>
          <Badge color='primary'>{job?.primaryJobCategory.name}</Badge>
        </div>
      )}
      <ContentOverviewItem
        label={t('月収')}
        text={`${getFormattedAmount(Number(job?.minMonthlySalary), job?.currencyUnit)} - ${getFormattedAmount(
          Number(job?.maxMonthlySalary),
          job?.currencyUnit
        )}`}
      />
      {job?.equityGrant && <ContentOverviewItem label={t('エクイティまたは SO の有無')} text={t('有り')} />}
      <ContentOverviewItem label={t('経験年数')} text={t(`jobs:${job?.workExperience}`)} />
      <ContentOverviewItem label={t('リモートの可否')} text={t(`jobs:${job?.workingForm}`)} />
      {job?.address && !(job?.workingForm === JobWorkingForm.REMOTE_ONLY) && (
        <ContentOverviewItem label={t('勤務地')} text={job?.address} />
      )}
    </div>
  )
}
